<div class="find-us-modal"
	id="findUs-dialog">
	<div class="content py-40"
		*ngIf="region === 'cn'">
		<div class="img-con pt-4 pb-40">
			<img class="qr-img"
				src="assets/images/wechat-qrcode.png"
				alt="{{ 'support.needHelp.listContactUsOnWechat' | translate}}"
				id="find-us-modal-wechat-qrcode"
				role="img" />
		</div>
		<div id="find-us-modal-basic-title" class="text-center title mb-2" role="text">{{ 'support.needHelp.listContactUsOnWechat' | translate}}</div>
		<div id="find-us-modal-description" class="text-center description" role="text">{{ 'support.needHelp.weChatDescription' | translate}}</div>
	</div>
	<div class="content py-40"
		*ngIf="region !== 'cn'">
		<a href="https://www.facebook.com/LenovoSupport"
			target="_blank"
			class="goto-facebook"
			id="find-us-goto-facebook"
			aria-label="find-us-goto-facebook">
			<div class="img-con pt-4 pb-40">
				<img class="fb-img"
					src="assets/images/logo-facebook.png"
					alt="{{ 'support.needHelp.listContactUsOnFacebook' | translate}}" />
			</div>
			<div id="find-us-modal-basic-title" class="text-center title mb-2" [innerHtml]="'support.needHelp.listContactUsOnFacebook' | translate"></div>
			<div class="text-center description" [innerHtml]="'support.needHelp.facebookDescription' | translate"></div>
		</a>
	</div>
	<div role="button"
		type="button"
		class="close-btn"
		id="find-us-close-button"
		aria-label="close"
		tabindex="0"
		(keydown.enter)="onCancelClick()"
		(click)="onCancelClick()">
		<img [src]=" 'assets/icons/Close.svg' | svgInline | async"
			alt=""
			srcset="">
	</div>
</div>
